const filters = {
  capitalize: function (value) {

    if (!value) return '';
    value = value.toString();
    return value.toUpperCase();
  }
};

export default filters;